module.exports = __webpack_public_path__ + "static/media/grass.2c7a84c9.svg";